<div class="row ss-top-menu">
  <div class="col-sm-12 d-flex">
        <span class="ss-text-light rk-activeLink addCursor" routerLink="/">Dashboard  </span>
        <span class="ml-5 mr-2" id="offlineText">I'm Offline</span>
        <div>
          <label class="switch">
            <input type="checkbox" id = "sliderCheckbox"  (change)="onchange($event.target)">
            <span class="slider round"></span>
          </label>
        </div>
        <span class="ml-2 notactivestatusText"  id="onlineText">I'm Online</span>
        <button class="btn btn-outline-secondary ml-auto mr-3 btn-lg bt-boq" type="button" data-toggle="modal" data-target="#addNewLeadModal" (click)="changeShowStatus('offline')">Add Lead</button>
        <button class="btn btn-outline-secondary btn-lg bt-boq p-2" type="button"
        data-toggle="modal" data-target="#callCustomerModal">Call to Lead</button>
        <button class="bt-boq btn btn-lg btn-outline-secondary mr-2 p-2 pull-right" type="button" data-toggle="modal" data-target="#inviteChampionModal" (click)="csagentinvitechampions.getChampionList()" *ngIf = "is_champion=='true'" style="width: 182px;">Invite Level 2 & Level 3 User</button>

  </div>
</div>
<div class="row marginTop pt-3 CsagentDashboardContainer" *ngIf="!showStatus && userAgentDetails">
  <div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
    <span id="notificationMessageText">{{errorMessage}}</span>
    <a class="close rk-linknotification" (click)="erroralert=false">×</a>
  </div>
  <div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
    <span id="notificationMessageText">{{successMessage}}</span>
    <a class="close rk-linknotification" (click)="successalert=false">×</a>
  </div>

  <div class="col-lg-12 mt-2 mb-4">
    <h5 class="titleText">Leads count by Status</h5>
  </div>
  <div class="col-sm-3 my-3">
    <div class="card py-2 px-2">
      <div class="mt-3 mb-4 ml-2 mr-1">
        <img src="assets/v3/img/claim.svg" class="cardHeadingIcon">
          <span class="statusCardHeadingColor ml-4">Claimed</span>
        </div>
        <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor">{{userAgentDetails.leads_claimed}}</h1>
        <div class="ml-3 mr-2 statusCardContent">
          <p>Count of all the leads which have been claimed by you.</p>
        </div>
    </div>
  </div>
  <div class="col-sm-3 my-3">
    <div class="card py-2 px-2">
      <div class="mt-3 mb-4 ml-2 mr-1">
        <img src="assets/v3/img/qualified.svg" class="cardHeadingIcon">
          <span class="statusCardHeadingColor ml-4">Qualified</span>
        </div>
        <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor">{{userAgentDetails.leads_qualified}}</h1>
        <div class="ml-3 mr-2 statusCardContent">
          <p>Count of all the leads which have been qualified.</p>
        </div>
    </div>
  </div>
</div>

<div class="row marginTop" *ngIf="showStatus">
  <div class="rk-ui-notification err" *ngIf="erroralert" style="z-index: 10000;">
    <span id="notificationMessageText">{{errorMessage}}</span>
    <a class="close rk-linknotification" (click)="erroralert=false">×</a>
  </div>
  <div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
    <span id="notificationMessageText">{{successMessage}}</span>
    <a class="close rk-linknotification" (click)="successalert=false">×</a>
  </div>
  <div class="col-12 px-2 mt-2 mb-5 leadDetailsContainer">

    <div class="card">
      <div class="headingBlock">
        <h6 class=" mt-2 mx-1">Lead Details <span class="pull-right">Timer - <span id="timer1">1:00</span> </span></h6>
      </div>
      <div class="row mx-1 text-center" *ngIf="activeLeadDataForAgent==undefined || activeLeadDataForAgent==null ">
        No leads are available .
      </div>
      <div class="row mx-1"  style="padding: 25px 10px 0px 0px;" *ngIf="activeLeadDataForAgent">
        <div class="col-md-4 mb-4">
          <label>Lead Name</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.name}}"  readonly>
        </div>
        <div class="col-md-4 mb-4">
          <label>Lead Email</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.email}}"  readonly>
        </div>
        <div class="col-md-4 mb-4">
          <label>Lead Contact Number</label>
          <input type="text" class="form-control" placeholder="{{ activeLeadDataForAgent.contact}}" readonly>

        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Date Of Acquisition</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.timestamp | date:'dd  MMM, yyyy'}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Time Of Acquisition</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.timestamp | date:'h:mma'}} ({{activeLeadDataForAgent.hours_ago }})" readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Pincode*</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.pincode}}" readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Lead Source</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_source | replaceChar}}" readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Lead Type</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_type | replaceChar}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Lead Campaign</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_campaign | replaceChar}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Lead Store</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_store.name | replaceChar}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2" *ngIf="activeLeadDataForAgent.referrer">
          <label>Referral Partner</label>
          <input type="text" class="form-control" *ngIf="activeLeadDataForAgent.referrer"  placeholder="{{activeLeadDataForAgent.referrer.name | replaceChar}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Status</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_status | replaceChar}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Fastrack Lead</label>
          <input *ngIf="activeLeadDataForAgent.from_fasttrack_page==false" type="text" class="form-control"  placeholder="No"  readonly>
          <input *ngIf="activeLeadDataForAgent.from_fasttrack_page==true" type="text" class="form-control"  placeholder="Yes"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2" *ngIf="activeLeadDataForAgent.lead_status=='follow_up'">
          <label>Follow up time</label>
          <p class="labelColor">{{activeLeadDataForAgent.follow_up_time | date:'dd/MM/yyyy @ h:mma'}}</p>
        </div>
        <div class="col-md-12 mb-4 mt-2" *ngIf="activeLeadDataForAgent.lead_status=='follow_up'">
          <label>Follow Up Remark</label>
          <p class="labelColor">{{activeLeadDataForAgent.remark}}</p>
        </div>
        <div class="col-md-12 mb-4">
          <button type="button" class="rk-interalBtnColor addCursor pull-right" style="width: 115px;" (click)="stopTimerAfterClaimLead(activeLeadDataForAgent.id); startTimer1();getUserQuestionnaireDetails(activeLeadDataForAgent.id,activeLeadDataForAgent.lead_status)">Claim Lead</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add lead modal -->
<div class="modal fade customModal" id="addNewLeadModal" tabindex="-1" role="dialog" aria-labelledby="addNewLeadModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <form (ngSubmit)="addLeadFormSubmit(addLeadForm.value); " [formGroup]="addLeadForm" class="form-horizontal" enctype="multipart/form-data" id="addLeadForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title modalTitle" id="exampleModalLabel"> Lead Details</h5>
        </div>
        <div class="modal-body">
          <div class="row mx-2">
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Name </label>
                <input type="text" class="form-control" name="name" placeholder="Enter Lead Name" formControlName="name">
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Lead Email</label>
                <input type="text" class="form-control" name="email" placeholder="Enter Lead Email" formControlName="email">
                <div *ngIf="addLeadForm.controls['email'].errors && !addLeadForm.controls['email'].pristine" class="text-danger">

                  <div [hidden]="addLeadForm.controls['email'].valid">Enter valid email.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Lead Contact <span>*</span></label>
                <input type="number" class="form-control" name="contact" placeholder="Enter Lead Contact" formControlName="contact" required min="0" (keydown)="numberCheck($event)">
                <div *ngIf="addLeadForm.controls['contact'].errors && !addLeadForm.controls['contact'].pristine" class="text-danger">
                  <div [hidden]="!addLeadForm.controls['contact'].errors.required">Contact is required.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Pincode</label>
                <input type="number" class="form-control" name="pincode" placeholder="Enter Lead Pincode" formControlName="pincode" min="0" (keydown)="numberCheck($event)">
              </div>
            </div>

            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Type <span>*</span></label>
                <select formControlName="lead_type_id" class="form-control capitalize" (change)="showLeadStatusDropdown($event.target.value); onChangeOfLeadType($event.target.value)">
                  <option value="" disabled>Select</option>
                  <option value="{{type.id}}" *ngFor="let type of lead_types">{{type.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Source <span>*</span></label>
                <select formControlName="lead_source_id" class="form-control capitalize">
                  <option value="" disabled>Select</option>
                  <option value="{{src.id}}" *ngFor="let src of lead_sources">{{src.name | replaceChar}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Campaign </label>
                <select formControlName="lead_campaign_id" class="form-control capitalize">
                  <option value="" disabled>Select</option>
                  <option value="{{camp.id}}" *ngFor="let camp of lead_campaigns">{{camp.name | replaceChar}}</option>
                </select>
              </div>
            </div>
            <!-- dropdown for lead store -->
            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Store </label>
                <select formControlName="lead_store_id" class="form-control capitalize">
                <option value="" disabled>Select</option>
                <option value="{{store.id}}" *ngFor="let store of lead_store_que_arr">{{store.store_name | replaceChar}}</option>
                </select>
              </div>
            </div>
            <!--Dropdown added-->
            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Referrer User Type <span class="astric" *ngIf="role != 'cs_agent'">*</span></label>
                <select formControlName="referrer_type" class="form-control capitalize" (change)="onChangeOfLeadSource($event.target.value)">
                  <option value="" disabled>Select</option>
                  <option value="{{src.name}}" *ngFor="let src of lead_referrer_list">{{src.name | replaceChar}}</option>
                </select>
              </div>
            </div>
            <!--Dropdown added-->
            <div class="col-sm-10 col-md-6 mb-2" *ngIf="['display_dealer_referral','non_display_dealer_referral','client_referral','design_partner_referral','broker','employee_referral','dealer','arrivae_champion','others','associate_partner','non_display_dealer'].includes(addLeadForm.controls['lead_source_type'].value) == true ">
              <div class="form-group">
                <label class="text-left">Referrer User<span class="astric">*</span></label>
                <ng-select formControlName="referrer_id" class="form-control capitalize border-0 p-0" placeholder="Select Referrer User">
                  <ng-option value="" disabled>Select</ng-option>
                  <ng-option value="{{camp.id}}" *ngFor="let camp of userList">{{camp.name }} - {{ camp.email}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 d-none" id="addLeadStatusDropdown">
              <div class="form-group">
                <label class="text-left">Select Lead Status <span>*</span></label>
                <select formControlName="lead_status" class="form-control capitalize" (change)="setLeadStatus($event.target.value)">
                  <option value="" disabled>Select</option>
                  <option value="qualified">Qualified</option>
                  <option value="follow_up">Follow Up</option>
                  <option value="lost">Lost</option>
                  <option value="not_contactable">Not Contactable</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6" *ngIf="addLeadForm.controls['lead_type_name'].value=='designer'">
              <div class="form-group">
                <label class="text-left">Instagram Id </label>
                <input type="text" formControlName="instagram_handle" name="" class="form-control">
              </div>
            </div>
            <div class="col-sm-10 col-md-6" *ngIf="addLeadForm.controls['lead_type_name'].value=='designer'">
              <div class="form-group">
                <label class="text-left">Upload CV </label>
                <input type="file" name="" class="form-control" (change)="uploadCV($event)" name="attachment_file">
              </div>
            </div>
            <div class="col-md-6" id="addleadFormdatetime" style="display: none;">
              <div class="form-group">
                <label class="text-left">Follow up Time<span>*</span></label>
                <!-- <input type="datetime-local" formControlName="follow_up_time" name="" class="form-control"> -->
                <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Enter Date and Time" formControlName="follow_up_time" class="form-control">
                <owl-date-time #dt1 ></owl-date-time>
              </div>
            </div>
            <div class="col-md-6" id="addleadFormRemark" style="display: none;">
              <div class="form-group">
                <label class="text-left">Follow up Remark<span>*</span></label>
                <input type="text" formControlName="remark" name="" class="form-control">
              </div>
            </div>
            <div class="col-md-6" id="addleadFormlostReason" style="display: none;">
              <div class="form-group">
                <label for="example-text-input" class="text-left">Reason for Lost <span class="text-danger">*</span></label>
                <div class="">
                  <select class="form-control" id="lost_reason" formControlName="lost_reason" (change)="reasonForLostDropdownChange($event.target.value)">
                    <option value="" disabled>Select Reason</option>
                    <option *ngFor="let reason of lostReasonsArr" value="{{reason}}">{{reason | replaceChar}}</option>
                  </select>
                  </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="addLeadForm.controls['lead_status'].value=='lost'"  id="addleadFormlostremark" style="display: none;">
              <div  class="form-group">
                <label >Remarks</label>
                <textarea class="form-control" rows="2" formControlName="lost_remark"></textarea>
              </div>
            </div>
            <div class="col-sm-12 mt-3 text-right">
              <div class="mt-3">
              <button type="submit" [disabled]="!addLeadForm.valid" class="rk-interalBtnColor addCursor">Add</button>
              <button class="cancle ml-3 addCursor rk-btnCancel" data-dismiss="modal" (click)="addLeadForm.reset()">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div id="addleadquestionnaireForm" style="display: none;overflow-y: auto">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title modalTitle" id="exampleModalLabel">Lead Questionnaire</h5>
        </div>
        <div class="modal-body addleadQuestionnaireModal">
          <div class="row justify-content-center">
            <div class="col-12">
              <app-leadquestionnaire [leadDetails]="addLeadDetails" (close)="closeModalQues($event)"></app-leadquestionnaire>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- lead details modal -->
<div class="modal fade" id="leadDetailsModal" tabindex="-1" role="dialog" aria-labelledby="leadDetailsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title modalTitle col-md-5" id="exampleModalLabel">Lead Details</div>
        <div class="modalTitle col-md-6 text-right" style="background:transparent;">Time left : <span id="timer">20:00</span></div>
        <button type="button"  (click)="closeModal();localityWebData=null" class="close close1">
          <i class="fa fa-close"></i>
          <!-- <img class="close" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg"> -->
        </button>
      </div>

      <div class="modal-body leadView" *ngIf="leadDetails">
        <div class="row addClass">
          <div *ngIf=" leadDetails.lead_type =='customer'" class="customer-details"><span>Customer Details</span></div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Name <span class="text-danger hideAsteriskIcon">*</span></label>
              <input type="text" class="form-control" placeholder="{{leadDetails.name}}" [(ngModel)]="leadName">
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Contact</label>
              <p class="addCursor"><span (click)="callLead(leadDetails.contact)" class="callText">Call To {{leadDetails.contact}} - </span><i class="fa fa-phone callIcon" (click)="callLead(leadDetails.id)"></i></p>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Date Of Acquisition (dd-mm-yyyy)</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.created_at | date:'dd  MMM, yyyy , h:mm a'}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Source</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lead_source | replaceChar}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Campaign</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lead_campaign | replaceChar}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Role</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lead_type}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Status</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lead_status | replaceChar | ucwords}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6" *ngIf="leadDetails.lead_status=='follow_up'">
            <div class="form-group" >
              <label>Follow up time</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.follow_up_time}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6" *ngIf="leadDetails.lead_status=='lost'">
             <div class="form-group" >
              <label>Remarks</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lost_remark}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Email </label>
              <input type="text" class="form-control" value="{{leadDetails.email}}" [(ngModel)]="leadEmail">
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Pincode <span class="text-danger"></span></label>
              <input type="text" class="form-control" placeholder="{{leadDetails.pincode}}" [(ngModel)]="leadPincode">
            </div>
          </div>
          <div class="col-sm-10 col-md-6" *ngIf="leadDetails.lead_type=='designer' ">
            <div class="form-group">
              <label>Instagram Id</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.instagram_handle}}" [(ngModel)]="leadInstagramhandle">
            </div>
          </div>
          <div class="col-sm-10 col-md-6" *ngIf="leadDetails.lead_type=='designer' ">
            <div class="form-group">
              <label>Upload CV</label>
              <input type="file" class="form-control" (change)="uploadCV($event)" name="attachment_file" id="cv_file_input">
              <a href="https://{{lead_designerCV}}" *ngIf="lead_designerCV && lead_designerCV !='/images/original/missing.png'" onerror="this.src='./assets/img/no_image.svg'" target="_blank">View CV</a>
            </div>
          </div>

          <div  *ngIf=" leadDetails && leadDetails.lead_type =='customer'" class="col-sm-12" style="width:100%">
              <div class="property-details">
                <span>Property Details</span>
              </div>
          </div>

          <div class="col-md-12">
            
            <div class="">
              <form [formGroup]="leadquestionnaire"  *ngIf=" leadDetails && leadDetails.lead_type =='customer'">
                <div class="row">
                 
                  <div class="col-md-6 mt-2">
                    <label class="customLabel">City Name <span class="text-danger hideAsteriskIcon">*</span></label>
                    
                    <div class="form-check">
               
                        <ng-select  formControlName="city" class="filterSelect dissplay-chng1" (change) = "onchangeCity($event)" >
                          <ng-option value="" disabled>Enter City Name</ng-option>       
                          <ng-option *ngFor="let city of citiesForQuestionnaire" [value]="city.name">{{city.name | replaceChar}}</ng-option>
                          <ng-option value="Others" >Others</ng-option>
                        </ng-select>
                        
                        <div class="form-check" *ngIf="this.cityChangeValue == 'Others'">
                          <input type="text" id="citybuilding" formControlName="new_city_value"  class = "form-control mt-3" placeholder="Enter the City name">
                        </div>
                    </div>
                  </div>
                  
                  <div class="mt-2 col-md-6 ">
                    <label class="customLabel">Society Name/Building</label>
                    
                    <div class="form-check">
                      <ng-select formControlName="society" class="filterSelect dissplay-chng1" (keyup)="searchSociety($event)" (change) = "changebuilding($event)"   >
                         
                          <ng-option value="" disabled>Enter Society/Building Name</ng-option>       
                          <ng-option *ngFor="let society of societyList" [value]="society">Society: {{society.building_name}} / Locality: {{society.locality}}</ng-option>
                          <ng-option value="Others" >Others</ng-option>
                      </ng-select>
                      
                      <div class="form-check" *ngIf="this.vaale=='Others'">
                          <input type="text" id="societybuildingCs" formControlName="new_society_value"  class = "form-control mt-3" placeholder="Enter society/building name"  >
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div class="row mt-2">
                  
                  <div class="form-group col-md-6">
                    <label class="customLabel">Locality<span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      
                      <ng-select disabled formControlName="location" class="filterSelect dissplay-chng1" (change) = "changeLocality($event)" >
                        <ng-option value="" disabled>Enter Locality Name</ng-option>       
                        <ng-option value="Others" >Others</ng-option>
                      </ng-select>
                      
                      <div class="form-check" *ngIf="this.localityChangeValue == 'Others'">
                        <input type="text" id="localitybuildingCs" formControlName="new_locality_value"  class = "form-control mt-3" placeholder="Enter the locality name">
                      </div>
                    </div>
                </div>
                    <div class="form-group col-md-6">
                      <label class="customLabel">Project Type <span class="text-danger hideAsteriskIcon">*</span></label>
                      <div class="form-check">
                        <label class="form-check-label labelColor lableSize mr-2">
                          <input class="form-check-input" type="radio" value="Residential" formControlName="project_type">
                          Residential
                        </label>
                        <label class="form-check-label labelColor lableSize mr-2">
                          <input class="form-check-input" type="radio" value="Offices" formControlName="project_type">
                          Offices
                        </label>
                      </div>
                    </div>
                    <div *ngIf="localityWebData && localityWebData.bhk.length>0" class="mt-2 data-web">
          
                        <h6>Data From Web</h6>
                        <div class="row">
                        <div class="col-sm-3" style="padding-top:0.7rem;">
                            <span  data-toggle="modal" data-target="#floorplanModalCs" data-backdrop="static" data-keyboard="false"  style="color:#D05C17;cursor: pointer">{{localityWebData.society}}</span>
                        </div>
                        <div class="col-sm-9">
                          <table class="table borderless table-design">
                            <thead>
                              <tr>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let data of localityWebData.bhk">
                                <td>{{data.type}}</td>
                                <td>{{data.area}} Sq Ft</td>
                                <td>{{data.price}}</td>
                                <td>{{data.possession || 'Ready to Move'}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      
              
                    </div>
                </div>
                
                <div class="row" [ngClass]="{'d-none':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                  <div class="form-group col-md-12 mt-4">
                      <label class="customLabel">Type of Accommodation <span class="text-danger hideAsteriskIcon">*</span></label>
                      <div class="form-check">
                        <label class="form-check-label labelColor lableSize mr-2 mb-2" *ngFor="let at of accommodation_type">
                          <input class="form-check-input" type="radio" value="{{at}}" formControlName="accomodation_type" >
                          {{at}}
                        </label>
                      </div>
                  </div>
                </div>
                <div class="row" [ngClass]="{'d-none':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Type of Home <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-2" *ngFor="let hometype of home_type_arr">
                        <input class="form-check-input" type="radio" value="{{hometype}}" formControlName="home_type">
                        {{hometype}}
                      </label>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>Purpose Of Property</label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-2"  *ngFor="let purpose of purpose_of_property">
                        <input class="form-check-input" type="radio" value="{{purpose}}" formControlName="purpose_of_property">
                        {{purpose}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row" (mouseleave)="taskChange()" (mouseenter)="taskChange()" >
                  <div class="form-group col-md-12">
                    <label class="customLabel">Possession status <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize mr-2 mb-2">
                        <input class="form-check-input" type="radio" value="Possession Taken" formControlName="possession_status" (click)="possesionStatusSelected('Possession Taken','leadQuestionnaire')">
                        Possession Taken
                      </label>
                      <label class="form-check-label labelColor lableSize">
                        <input class="form-check-input" type="radio" value="Awaiting Possession" formControlName="possession_status" (click)="possesionStatusSelected('Awaiting Possession','leadQuestionnaire')">
                        Awaiting Possession (If Yes, please fill the date of possession below on "other")
                      </label>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="this.leadquestionnaire.controls['possession_status'].value =='Awaiting Possession'"> 
                    <div class="form-group col-md-12" id="Vpossesiondate">
                      <label class="customLabel">Estimated month of Possession: <span class="text-danger hideAsteriskIcon">*</span></label>
                      <!-- <select formControlName="possession_status_date" class="form-control">
                        <option value="" disabled>Choose</option>
                        <option value="{{est}}" *ngFor="let est of estimatedPossessionTime">{{est}}</option>
                      </select> -->
                      <input name="startDateCs" id="startDateCs" class="date-picker" (focus)="callChangeNew()"  formControlName="possession_status_date" placeholder="Choose A Month..."/>
                    </div>
                  </div>
                </div>
                <div class="row d-none" [ngClass]="{'d-block':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Status of Property <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-2" *ngFor="let spo of status_of_property_offices">
                        <input type="radio" class="form-check-input" value="{{spo}}" formControlName="status_of_property">
                        {{spo}}
                      </label>
                    </div>
                  </div>
                </div>
 

                <div class="row">
                  <div class="form-group col-md-6" [ngClass]="{'d-none':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                    <label class="customLabel">Home Value(In Rs Lacs)<span class="hideAsteriskIcon text-danger">*</span></label>
                    <select formControlName="home_value" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Above 2.50 Cr"
                        selected="this.leadquestionnaire.controls['home_value'].value === 'Above 2.50 Cr'"
                        *ngIf="this.leadquestionnaire.controls['home_value'].value === 'Above 2.50 Cr'" disabled>
                        Above 2.50 Cr
                      </option>
                      <ng-container *ngFor="let hv of home_value_arr">
                        <option value="{{hv}}">{{hv}}</option>
                      </ng-container>
                    </select>
                  </div>
                  <div class="col-sm-10 col-md-6 form-group" [ngClass]="{'d-none':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                    <label class="customLabel">Budget Value(In Rs Lacs)<span class="hideAsteriskIcon text-danger">*</span></label>
                    <select formControlName="budget_value" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="{{bvh}}" *ngFor="let bvh of budget_value_home">{{bvh}}</option>
                    </select>
                  </div>
                  <div class="col-sm-10 col-md-6 form-group d-none" [ngClass]="{'d-block':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                    <label class="customLabel">Budget Value(In Rs Lacs)<span class="hideAsteriskIcon text-danger">*</span></label>
                    <select formControlName="budget_value" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="{{bvh1}}" *ngFor="let bvh1 of budget_value_office">{{bvh1}}</option>
                    </select>
                  </div>
                </div>

                <div class="row" [ngClass]="{'d-none':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                  <div class="form-group col-md-12">
                    <label>Do you have a home loan against the property? <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-2"  *ngFor="let haveloan of have_homeloan_arr">
                        <input class="form-check-input" type="radio" value="{{haveloan}}" formControlName="have_homeloan">
                        {{haveloan}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row" [ngClass]="{'d-none':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                  <div *ngIf="leadquestionnaire.controls['project_type'].value=='Residential'" class="form-group col-md-6">
                    <label class="customLabel">Do you have a floor plan? </label>
                    <div class="form-check">
                      <label class="form-check-label mr-4 labelColor lableSize">
                        <input class="form-check-input" type="radio" value="Yes" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('yes','floorplanQuestionnaire1')">
                        Yes
                      </label>
                      <label class="form-check-label labelColor lableSize">
                        <input class="form-check-input" type="radio" value="No" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('no','floorplanQuestionnaire1')">
                        No
                      </label>
                    </div>
                  </div>
                  <div class="form-group col-md-6" id="floorplanQuestionnaire1" style="display: none;">
                    <label class="customLabel">Upload Floorplan</label>
                    <div class="form-check">
                      <input class="form-control ss-form-control" type="file" (change)="onQuestionnaireFloorplanChange($event)" name="floorplan_attachment_file" ngModel #floorplan_attachment_file="ngModel" [ngModelOptions]="{standalone: true}" id="floorplan_file_input">
                    </div>
                    <p id="extErrorMsg" class="text-danger d-none col-sm-10">Check File extension (File should be in proper image format).</p>
                    <p class="col-sm-10">Note* - Only Image, Doc and PDF files are allowed.  </p>
                  </div>
                  <div class="form-group col-md-6" *ngIf="leadquestionnaire.controls['lead_floorplan'].value != '/images/original/missing.png' && leadquestionnaire.controls['have_floorplan'].value=='Yes'">
                    <label class="customLabel">Uploaded Floorplan</label>
                    <div class="form-check">
                      <a href="{{leadquestionnaire.controls['lead_floorplan'].value}}" target="_blank"  style="color: #007bff">View Floorplan </a>
                    </div>
                  </div>
                </div>

                <div class="row mt-2 d-none" [ngClass]="{'d-block':(leadquestionnaire.controls['project_type'].value=='Residential')}">
                  <div class="col-sm-6 form-group">
                    <label class="customLabel">Area of the Site (sq ft)<span class="text-danger hideAsteriskIcon">*</span></label>
                    <input type="number" name="" class="form-control" min="0" formControlName="area_of_site">
                  </div>
                </div>
                <div class="row d-none" [ngClass]="{'d-block':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                  <div class="form-group col-md-6">
                    <label class="customLabel">Project Commencement Date <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" placeholder="Enter Date" formControlName="project_commencement_date" class="form-control">
                      <owl-date-time #dt2 [pickerType]="'calendar'"></owl-date-time>
                    </div>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="customLabel">Area of the Site (sq ft)<span class="text-danger hideAsteriskIcon">*</span></label>
                    <input type="number" name="" class="form-control" min="0" formControlName="area_of_site">
                  </div>

                  <div class="col-sm-12 form-group ">
                    <label class="customLabel">Address of Site<span class="text-danger hideAsteriskIcon">*</span></label>
                    <textarea formControlName="address_of_site" class="form-control"></textarea>
                  </div>

                  <div class="col-sm-12 form-group ">
                    <label class="customLabel">Type of Space<span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-2"  *ngFor="let tso of type_of_space_office">
                        <input class="form-check-input" type="radio" value="{{tso}}" formControlName="type_of_space">
                        {{tso}}
                      </label>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="customLabel">Layout and Photographs of Site<span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-4">
                        <input class="form-check-input" type="radio" value="Yes" formControlName="layout_and_photographs_of_site"> Yes
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4">
                        <input class="form-check-input" type="radio" value="No" formControlName="layout_and_photographs_of_site"> No
                      </label>
                    </div>
                  </div>

                </div>
                <div class="row d-none" [ngClass]="{'d-block':(leadquestionnaire.controls['project_type'].value=='Offices' &&  leadquestionnaire.controls['layout_and_photographs_of_site'].value=='Yes')}">
                  <div class="col-sm-12 my-3">
                    <label class="customLabel">Upload Layouts and Photographs<span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <input type="file" name="" class="form-control ss-form-control" multiple="multiple" id = "fileupload" (change) = "attachFile($event)">
                    </div>
                  </div>
                  <div class="col-sm-12 my-3" *ngIf=" leadquestionnaire.controls['project_type'].value=='Offices' && leadquestionnaire.controls['layout_and_photographs_of_site'].value=='Yes' && userQuestionnaireDetails && userQuestionnaireDetails.length>0 && userQuestionnaireDetails[0].site_layouts && userQuestionnaireDetails[0].site_layouts.length>0">
                    <label class="customLabel">Uploaded Layouts and Photographs</label><br>
                    <div class="form-check d-inline-block" *ngFor="let imgurl of userQuestionnaireDetails[0].site_layouts; let k1=index;">
                      <a href="{{imgurl}}" target="_blank"  style="color: #007bff" class="addCursor mr-3">Image{{k1+1}} </a>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                    <div class="customer-details">
                      <span>Scope Details</span>
                    </div>
                </div>
                
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Scope of Work <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize mr-2 mb-2" *ngFor="let sw of scopeOfwork_home">
                        <input type="radio" class="form-check-input" formControlName="scope_of_work" value="{{sw}}">
                        {{sw}}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="budget-calculator">
                    <label class="customLabel text-dark font-weight-bold">Scope of Work/Budget Calculator</label><br>            
                    <div class="row">
                      <div class="col-sm-5">
                        <label class="customLabel mt-2">Item</label>
                        <input type="text" (keyup)="searchquestionarrieItem($event)"  [(ngModel)]="searchname" name="searchname" [ngModelOptions]="{standalone: true}" autocomplete="off" class="form-control " placeholder="Search By Name"><br>
                          <label *ngIf="!this.searchstatus" class=" alert alert-danger" id="notfound">Item not found, Please add custom item.<span>
                          <i style="font-size:12px" class="fa fa-remove color-crimson2 addCursor float-right" (click)="hide()"></i>
                          </span></label>
                          <br>
                          <ul *ngIf="searchList" class="ks-cboxtags" id="myUL">
                            <li *ngFor="let item of searchList.slice(0,10);let i = index">
                              <span *ngIf="leadItemscheckedListNames.includes(item.name.toLowerCase())">
                                <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}" (change)="isAllSelected($event)" value="{{item.name}}" checked> 
                                <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                              </span>
                              <span *ngIf="!leadItemscheckedListNames.includes(item.name.toLowerCase())">
                                  <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}" (change)="isAllSelected($event)" value="{{item.name}}">
                                  <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                              </span>
                            </li>
                            <li data-toggle="tooltip" title="Search for additional items." *ngIf="searchList.length>10">
                                <span>
                                    <input onclick="return false;" type="checkbox" id="more" value="More...">
                                    <label for="more">More...</label>
                                </span>
                            </li>
                          </ul>
                      </div>
                      
                      <div class="col-sm-7">
                          <table *ngIf="checkedList.length > 0" class="mt-2">
                              <tr>
                                <th class="text-center text-design">Name</th>
                                <th class="text-center text-design">Price</th>
                                <th class="text-center text-design">Quantity</th>
                                <th class="text-center text-design">Total</th>
                                <th class="text-center text-design"></th>
                              </tr>
                              <tr class="input-design" *ngFor="let budgetdata of checkedList" cellspacing="10">
                                <td><input type="text" class="form-control" value="{{budgetdata.name}}" readonly/></td>
                                <td>
                                  <input type="text" class="form-control" value="{{budgetdata.price}}" readonly/>
                                </td>
                                <td>
                                  <input type="number" min="1" class="form-control text-center" value="{{budgetdata.quantity}}" (change)="valuechange(budgetdata)" [(ngModel)] = "budgetdata.quantity" [ngModelOptions]="{standalone: true}">
                                </td>
                                <td>
                                  <input type="text" class="form-control text-center" value="{{budgetdata.quantity * budgetdata.price}}" readonly/>
                                </td>
                                <td>
                                    <i style="font-size:15px" class="fa addCursor" (click)="removequestionaireitesm(budgetdata)">&#xf00d;</i>
                                </td> 
                               </tr>
                            </table>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-5">
                        <button (click)="showAddOtherItem()" id="addMoreLeadItemBtnCsAgent" class="form-control color-crimson float-right addCursor">+ Add new</button>
                        <input type="text" placeholder="Enter the custom item" id="otherLeadItemCsAgent" class="form-control hide" name="name">
                        <button (click)="SaveOtherLeadItem($event)" id="submitOtherLeadBtnCsAgent" class="form-control color-crimson hide mt-1 addCursor">Add Custom Item</button>
                      </div>
                      <div class="col-sm-3">
                          
                      </div>
                      <div class="col-sm-4">
                          <p style="text-align: end" *ngIf="checkedList.length > 0" >Total: <i class="fas fa-rupee-sign total-cost-text"></i> {{this.totalBudget}}</p>
                      </div>
                    </div>
                  </div>
                
                <!-- <div class="row mt-4">
                  <div class="form-group col-md-6" >
                    <label class="customLabel">When would you like us to start work?<span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <input [owlDateTime]="dt5" [owlDateTimeTrigger]="dt5" placeholder="Enter Date" formControlName="intended_date" class="form-control" (dateTimeChange)="onChange($event)">
                      <owl-date-time #dt5 [pickerType]="'calendar'"></owl-date-time>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="row mt-2 d-none" [ngClass]="{'d-block':(leadquestionnaire.controls['project_type'].value=='Residential')}">
                  <div class="col-sm-6 form-group">
                    <label class="customLabel">Area of the Site (sq ft)<span class="text-danger hideAsteriskIcon">*</span></label>
                    <input type="number" name="" class="form-control" min="0" formControlName="area_of_site">
                  </div>
                </div> -->
                <!-- <div class="row d-none" [ngClass]="{'d-block':(leadquestionnaire.controls['project_type'].value=='Offices')}">
                   <div class="form-group col-md-6">
                    <label class="customLabel">Project Commencement Date <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" placeholder="Enter Date" formControlName="project_commencement_date" class="form-control">
                      <owl-date-time #dt2 [pickerType]="'calendar'"></owl-date-time>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="customLabel">Area of the Site (sq ft)<span class="text-danger hideAsteriskIcon">*</span></label>
                    <input type="number" name="" class="form-control" min="0" formControlName="area_of_site">
                  </div>
                  <div class="col-sm-12 form-group ">
                    <label class="customLabel">Address of Site<span class="text-danger hideAsteriskIcon">*</span></label>
                    <textarea formControlName="address_of_site" class="form-control"></textarea>
                  </div>
                  <div class="col-sm-12 form-group ">
                    <label class="customLabel">Type of Space<span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-2"  *ngFor="let tso of type_of_space_office">
                        <input class="form-check-input" type="radio" value="{{tso}}" formControlName="type_of_space">
                        {{tso}}
                      </label>
                    </div>
                  </div>
                  <div class="form-group col-sm-12">
                    <label class="customLabel">Layout and Photographs of Site<span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-4">
                        <input class="form-check-input" type="radio" value="Yes" formControlName="layout_and_photographs_of_site"> Yes
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4">
                        <input class="form-check-input" type="radio" value="No" formControlName="layout_and_photographs_of_site"> No
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row d-none" [ngClass]="{'d-block':(leadquestionnaire.controls['project_type'].value=='Offices' &&  leadquestionnaire.controls['layout_and_photographs_of_site'].value=='Yes')}">
                  <div class="col-sm-12 my-3">
                    <label class="customLabel">Upload Layouts and Photographs<span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <input type="file" name="" class="form-control ss-form-control" multiple="multiple" id = "fileupload" (change) = "attachFile($event)">
                    </div>
                  </div>
                  <div class="col-sm-12 my-3" *ngIf=" leadquestionnaire.controls['project_type'].value=='Offices' && leadquestionnaire.controls['layout_and_photographs_of_site'].value=='Yes' && userQuestionnaireDetails && userQuestionnaireDetails.length>0 && userQuestionnaireDetails[0].site_layouts && userQuestionnaireDetails[0].site_layouts.length>0">
                    <label class="customLabel">Uploaded Layouts and Photographs</label><br>
                    <div class="form-check d-inline-block" *ngFor="let imgurl of userQuestionnaireDetails[0].site_layouts; let k1=index;">
                      <a href="{{imgurl}}" target="_blank"  style="color: #007bff" class="addCursor mr-3">Image{{k1+1}} </a>
                    </div>
                  </div>
                </div> -->
          
                <div class="row" (mouseleave)="workChange()" (mouseenter)="workChange()">
                  <div class="form-group col-md-6 mt-4">
                      <label class="customLabel">When Would You Like To Start Work ? <span class="text-danger hideAsteriskIcon">*</span></label>
                      <input name="startDateCswork" id="startDateCswork" class="work-date-picker" (focus)="DateForWorkStart()"  formControlName="intended_date" placeholder="Choose A Month..."/>
                  </div>
                  <div class="form-group col-md-6"></div>
                  <div class="form-group col-md-6">
                    <label class="customLabel">Call Back Day <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Enter Date" formControlName="call_back_day" class="form-control">
                      <owl-date-time #dt1 [pickerType]="'calendar'"></owl-date-time>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="customLabel">Call Back Time </label>
                    <div class="form-check">
                      <select formControlName="call_back_time" class="form-control">
                        <option value="" disabled>Choose</option>
                        <option value="{{cb}}" *ngFor="let cb of callbacktime">{{cb}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-10 col-md-6" >
                    <div class="form-group">
                      <label class="text-left">Select Theme </label>
                      <select formControlName="theme" class="form-control capitalize">
                      <option value="" disabled>Select</option>
                      <option value="{{theme.id}}" *ngFor="let theme of themeList">{{theme.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-10 col-md-6">
                  <div class="form-group">
                    <label class="text-left">Select Life Stage  <span class="text-danger hideAsteriskIcon">*</span></label>
                    <select formControlName="lifestage" class="form-control capitalize">
                    <option value="" disabled>Select</option>
                    <option value="{{stage.id}}" *ngFor="let stage of lifeStageList">{{stage.name | replaceChar}}</option>
                    </select>
                  </div>
                  </div>
                </div>
                
                <div class="row">
                <div class="col-sm-12 mt-2">
                  <div class="form-group">
                    <label class="customLabel">Would you like to visit our EC ?</label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-4">
                        <input class="form-check-input" type="radio" [value]="true" formControlName="visit_ec" (click)="ec(true)">
                        Yes
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4">
                        <input class="form-check-input" type="radio" [value]="false" formControlName="visit_ec" (click)="ec(false)">
                        No
                      </label>
                    </div>
                  </div>
                </div>
                </div>
        
                <ng-container *ngIf="this.selectstatusforec">
                    <div class="row mt-2">
                        <!-- <label class="customLabel">Call Back Day <span class="text-danger hideAsteriskIcon">*</span></label> -->
                        <div class="col-sm-6 form-check">
                          <!-- <input [min]="selectedMoment" [owlDateTime]="ec_date" [owlDateTimeTrigger]="ec_date" placeholder="Enter Date (Date should be greater than the current date)" formControlName="visit_ec_date" class="form-control"> -->
                          <input [owlDateTime]="ec_date" [owlDateTimeTrigger]="ec_date" placeholder="Enter Date (Date should be greater than the current date)" formControlName="visit_ec_date" class="form-control">
                          <owl-date-time #ec_date [pickerType]="'calendar'" [startView]="'month'"></owl-date-time> 
                        </div>
                      </div>
                </ng-container>
              <div class="row">
              <div class="col-sm-12 mt-2">
                  <div class="form-group">
                    <label class="customLabel">Do you need Site Measurement ?</label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-4">
                        <input class="form-check-input" type="radio" [value]="true" formControlName="site_measurement_required" (click)="sitemeasurement(true)">
                        Yes
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4">
                        <input class="form-check-input" type="radio" [value]="false" formControlName="site_measurement_required" (click)="sitemeasurement(false)">
                        No
                      </label>
                    </div>
                  </div>
              </div>
            </div>
            <ng-container *ngIf="this.selectstatusforsitemeasurement">
                <div class="row mt-2">
                    <!-- <label class="customLabel">Call Back Day <span class="text-danger hideAsteriskIcon">*</span></label> -->
                    <div class="col-sm-6 form-check">
                      <!-- <input [min]="selectedMoment" [owlDateTime]="mes" [owlDateTimeTrigger]="mes" placeholder="Enter Date  (Date should be greater than the current date)" formControlName="site_measurement_date" class="form-control"> -->
                      <input [owlDateTime]="mes" [owlDateTimeTrigger]="mes" placeholder="Enter Date  (Date should be greater than the current date)" formControlName="site_measurement_date" class="form-control">
                      <owl-date-time #mes [pickerType]="'calendar'"></owl-date-time> 
                    </div>
                  </div>
                </ng-container>
                <!-- <div class="row mt-2">
                    <div class="col-sm-6 form-group">
                      <label class="customLabel">When is a good time for our designer to call ?</label>
                      <div class="form-check">
                        <label style="width:100%" class="lableSize labelColor mb-2 mr-4">
                          <input id="designer_call" [min]="selectedMoment" [owlDateTime]="designer_call" [owlDateTimeTrigger]="designer_call" placeholder="Enter Date (Date should be greater than the current date)" formControlName="good_time_to_call" class="form-control">
                          <owl-date-time #designer_call [pickerType]="'both'" [startView]="'month'"></owl-date-time> 
                        </label>
                      </div>
                    </div>
                </div> -->

                <div class="row mt-4">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Additional Comments</label>
                    <div class="form-check">
                      <textarea rows="2" class="form-control" formControlName="additional_comments"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-12">
                        <label style="display:block" class="customLabel">Any Alternate Contact ?</label>
                        <button type="button" class="btn btn-pink addCursor" (click)="addAlternateNumberForm()">Add Alternate Number </button>
                        <span class="font-weight-bold ml-0 pl-0" *ngIf="hideAlternateNumberButton">Alternate Number:</span>
                      </div>
                    <div *ngIf="showAlternateForm">
                      <form [formGroup]="alternateNumberMasterForm">
                        <div formArrayName="alternate_contacts" *ngFor="let item of alternateNumberMasterForm.get('alternate_contacts')['controls']; let i = index;">
                            <div class="row" [formGroupName]="i">
                              <div class="col-12 mb-1 form-group">
                                <div class="col-12">
                                    <label>Alternate Number: {{i+1}}</label>
                                    <span class="pull-right addCursor d-block" (click)="removeAlternateNumber(i)"><i class="fa fa-minus-circle minus-icon"></i></span>    
                                </div>
                                <div class="col-6 d-inline-block mb-1">
                                 <span class="col-12 mb-1 pl-0">Name: </span> <input class="col-12 mb-1 d-inline-block form-control" type="text" formControlName="name" placeholder="Name">
                                </div>
                               <div class="col-6 d-inline-block mb-1">
                                <span class="col-12 mb-1 pl-0">Relation:</span> <input class="col-12 mb-1 d-inline-block form-control" type="text" formControlName="relation" placeholder="Relation">
                               </div>
                                <div class="col-6 d-inline-block mb-1">
                                  <span class="col-12 mb-1 pl-0">
                                      Contact: 
                                  </span>
                                  <input class="col-12 mb-1 form-control" type="text" formControlName="contact" placeholder="Contact">
                                </div>
                               </div>
                            </div>
                            <br>
                          </div>
                        </form>
                    </div>
                  </div>
              </form>
              <form [formGroup]="leadStatusUpdateForm">
                <div class="row">
                  <!-- //V:It will show when Awaiting Possession selected and intended date not selected // -->
                  <!-- <div class="col-md-6 p-0" *ngIf="this.leadquestionnaire.controls['possession_status'].value =='Awaiting Possession' && this.leadquestionnaire.controls['intended_date'].value==''" style="min-width: 100%">
                    <div class="col-md-6 p-0" style="min-width: 100%">
                      1
                      <div class="col-md-6" id="normalStatV">
                        <label>Change Status</label>
                        <select class="form-control" (change)="setLeadStatus($event.target.value)" formControlName="lead_status" id="chnagestatusDropDown">
                          <option value="" disabled>Select Status</option>
                          <option value="qualified">Qualified</option>
                          <option value="follow_up">Follow Up</option>
                          <option value="lost">Lost</option>
                          <option value="not_contactable">Not Contactable</option>
                        </select>
                      </div>
                      <div class="col-md-6" id="delyedV" style = "display: none;">
                        <div class="form-group">
                          <label class="customLabel">Change Status</label>
                          <select class="form-control" formControlName="lead_status" (change)="setLeadStatus($event.target.value)">
                            <option value="" >Select Status</option>
                            <option value="delayed_possession">Delayed Possession</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- //V:It will show when Awaiting Possession not selected and intended date selected // -->
                  <!-- <div class="col-md-6 p-0" *ngIf="this.leadquestionnaire.controls['intended_date'].value
                  !='' && this.leadquestionnaire.controls['possession_status'].value !='Awaiting Possession'" style="min-width: 100%">
                    <div class="col-md-6 p-0" style="min-width: 100%">
                      2
                      <div class="col-md-6" id="VnormalStat">
                        <label>Change Status</label>
                        <select class="form-control" (change)="setLeadStatus($event.target.value)" formControlName="lead_status" id="chnagestatusDropDown">
                          <option value="" disabled>Select Status</option>
                          <option value="qualified">Qualified</option>
                          <option value="follow_up">Follow Up</option>
                          <option value="lost">Lost</option>
                          <option value="not_contactable">Not Contactable</option>
                        </select>
                      </div>
                      <div class="col-md-6" id="Vdelyed" tyle = "display: none;">
                        <div class="form-group">
                          <label class="customLabel">Change Status</label>
                          <select class="form-control" formControlName="lead_status" (change)="setLeadStatus($event.target.value)">
                            <option value="" >Select Status</option>
                            <option value="delayed_project">Delayed Project</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- //V:It will show when Awaiting Possession selected and intended date selected (both selected)// -->
                  <!-- <div class="col-md-6 p-0" *ngIf="this.leadquestionnaire.controls['intended_date'].value
                  !='' && this.leadquestionnaire.controls['possession_status'].value =='Awaiting Possession'" style="min-width: 100%">
                    <div class="col-md-6 p-0" style="min-width: 100%">
                      3
                      <div class="col-md-6" id="VnormalStat">
                        <label>Change Status</label>
                        <select class="form-control" (change)="setLeadStatus($event.target.value)" formControlName="lead_status" id="chnagestatusDropDown">
                          <option value="" disabled>Select Status</option>
                          <option value="qualified">Qualified</option>
                          <option value="follow_up">Follow Up</option>
                          <option value="lost">Lost</option>
                          <option value="not_contactable">Not Contactable</option>
                         </select>
                      </div>
                      <div class="col-md-6" id="Vdelyed" style = "display: none;">
                        <div class="form-group">
                          <label class="customLabel">Change Status</label>
                          <select class="form-control" formControlName="lead_status" (change)="setLeadStatus($event.target.value)">
                            <option value="" >Select Status</option>
                            <option value="delayed_possession">Delayed Possession</option>
                            <option value="delayed_project">Delayed Project</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <div class="col-md-6 p-0" *ngIf="this.leadquestionnaire.controls['intended_date'].value
                  !='' || this.leadquestionnaire.controls['possession_status'].value =='Awaiting Possession'" style="min-width: 100%">
                    <div class="col-md-6 p-0" style="min-width: 100%">
                      <div class="col-md-6" id="VnormalStat">
                        <label>Change Status</label>
                        <select class="form-control" (change)="setLeadStatus($event.target.value)" formControlName="lead_status" id="chnagestatusDropDown">
                          <option value="" disabled>Select Status</option>
                          <option value="qualified">Qualified</option>
                          <option value="follow_up">Follow Up</option>
                          <option value="lost">Lost</option>
                          <option value="not_contactable">Not Contactable</option>
                         </select>
                      </div>
                      <div class="col-md-6" id="Vdelyed" style = "display: none;">
                        <div class="form-group">
                          <label class="customLabel">Change Status</label>
                          <select class="form-control" formControlName="lead_status" (change)="setLeadStatus($event.target.value)">
                            <option value="" >Select Status</option>
                            <option value="delayed_possession">Delayed Possession</option>
                            <option value="delayed_project">Delayed Project</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- //V:It will show when Awaiting Possession  and intended date both not selected)// -->
                  <div class="col-md-6 p-0" *ngIf="this.leadquestionnaire.controls['intended_date'].value=='' && this.leadquestionnaire.controls['possession_status'].value !='Awaiting Possession'" style="min-width: 100%">
                    <div class="col-md-6 p-0" style="min-width: 100%">
                      <div class="col-md-6">
                        <label>Change Status</label>
                        <select class="form-control" (change)="setLeadStatus($event.target.value)" formControlName="lead_status" id="chnagestatusDropDown">
                          <option value="" disabled>Select Status</option>
                          <option value="qualified">Qualified</option>
                          <option value="follow_up">Follow Up</option>
                          <option value="lost">Lost</option>
                          <option value="not_contactable">Not Contactable</option>
                         </select>
                      </div>
                    </div>
                  </div>
                  <!-- ---------------------------------- -->
                  <!-- V:end here -->
                  <div class="col-6" id="datetime" style="display: none;">
                    <div class="form-group">
                      <label>Follow up time</label>
                      <!-- <input class="form-control" type="datetime-local" formControlName="follow_up_time"> -->
                      <input [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3" placeholder="Enter Date & Time" formControlName="follow_up_time" class="form-control">
                      <owl-date-time #dt3 ></owl-date-time>
                    </div>
                  </div>
                  <div class="col-6" id="remarkChange" style="display: none;">
                    <div class="form-group">
                      <label>Follow up Remark</label>
                      <input class="form-control" type="text" formControlName="remark">
                    </div>
                  </div>
                  <div class="col-md-6" id="lostreason" style="display: none;">
                    <div class="form-group">
                      <label for="example-text-input" class="text-left">Reason for Lost <span class="text-danger">*</span></label>
                      <div class="">
                        <select class="form-control" id="lost_reason" formControlName="lost_reason" (change)="reasonForLostDropdownChange2($event.target.value)">
                          <option value="" disabled>Select Reason</option>
                          <option *ngFor="let reason of lostReasonsArr" value="{{reason}}">{{reason | replaceChar}}</option>
                        </select>
                        </div>
                    </div>
                  </div>
                  <div class="col-6" style="display: none;" id="lostremark">
                    <div class="form-group">
                      <label >Remarks</label>
                      <textarea class="form-control" rows="2" formControlName="lost_remark"></textarea>
                    </div>
                  </div>
                </div>
              </form><br>
              <div class="text-right">
                <button class="rk-interalBtnColor addCursor" (click)="updateStatus(leadStatusUpdateForm.value,leadquestionnaire.value,leadDetails.id);" id="updateStatusBtn" [disabled]= "leadquestionnaire.invalid  || leadStatusUpdateForm.invalid || (leadquestionnaire.valid && leadquestionnaire.controls['location'].value=='Others' && (!leadquestionnaire.controls['new_locality_value'].value)) || (leadquestionnaire.valid && leadquestionnaire.controls['society'].value=='Others' && (!leadquestionnaire.controls['new_society_value'].value)) || (leadquestionnaire.valid && leadquestionnaire.controls['city'].value=='Others' && (!leadquestionnaire.controls['new_city_value'].value)) || (leadquestionnaire.valid && leadStatusUpdateForm.controls['lead_status'].value=='qualified' && (leadName==''))" [ngClass]="{'cursor-notallowed':(leadquestionnaire.invalid  || leadStatusUpdateForm.invalid || (leadquestionnaire.valid && leadquestionnaire.controls['location'].value=='Others' && (!leadquestionnaire.controls['new_locality_value'].value)) || (leadquestionnaire.valid && leadquestionnaire.controls['society'].value=='Others' && (!leadquestionnaire.controls['new_society_value'].value)) || (leadquestionnaire.valid && leadquestionnaire.controls['city'].value=='Others' && (!leadquestionnaire.controls['new_city_value'].value)) || (leadquestionnaire.valid && leadStatusUpdateForm.controls['lead_status'].value=='qualified' && (leadName=='')))}">Update</button>
              </div>
              <!-- <pre>{{ leadquestionnaire.value | json}}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="callCustomerModal" role="dialog" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 text-right">
            <button type="button" class="close pull-right addCursor" data-dismiss="modal" style="height: 38px;"
            (click)="clearCallCustomerForm()">&times;</button>
          </div>
        </div>
        <div class="modal-body mb-5">
            <div class="row pb-0">
                <div class="col-12 pb-0">
                  <form [formGroup]="callCustomerForm">
                    <div class="row m-0 p-0 pl-5 pr-5">
                      <div class="col-xs-6 col-md-6 p-0 pr-2 pt-2 text-left">Mobile Number<span class="text-danger">*</span>:</div>
                      <div class="col-xs-6 col-md-6 p-0 d-inline-block pull-right">
                        <input type="text" class="form-control" placeholder="Mobile Number..." formControlName="contact_number"/>
                      </div>
                      <div *ngIf="callCustomerForm.controls['contact_number'].errors && !callCustomerForm.controls['contact_number'].pristine" class="text-danger">

                          <div [hidden]="callCustomerForm.controls['contact_number'].valid">Enter valid Number.</div>
                        </div>
                    </div>
                    <div class="border-change text-center pb-0 mt-4">
                      <button class="rk-interalBtnColor addCursor p-2" type="submit" (click)="callToCustomer()" style="width:70px">Submit</button>
                      <button class="btn addCursor" (click)="clearCallCustomerForm()">Cancel</button>
                    </div>
                  </form>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>

<!-- Invite Champion Modal -->
<div class="modal fade customModal" id="inviteChampionModal" tabindex="-1" role="dialog" aria-labelledby="inviteChampionModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="inviteChampionModalLabel">User Details</h5>
      </div>

      <div class="modal-body">
        <app-invite-champions #csagentinvitechampions></app-invite-champions>
      </div>
    </div>
  </div>
</div>

<div id="floorplanModalCs" class="modal" role="dialog">
    <div class="modal-dialog floorplan-position">
        <!-- Modal content-->
        <div style="border: 3px solid #6F0000;margin-top:30%" class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">List of floorplans present:</h6>
            <button (click)="closeFloorplanModal()" type="button" class="close" ><i class="fa fa-close"></i></button>
          </div>
          <div class="modal-body floorplan-design">
              <table *ngIf="localityWebData" class="table">
                  <thead>
                    <tr>
                      <th style="text-align:center">#</th>
                      <th style="text-align:center">Floorplan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let floorplan of localityWebData.floorplan;let i=index">
                      <td style="text-align:center">{{i+1}}</td>
                      <td style="text-align:center;"><a style="color:#6F0000;" href="{{floorplan}}" target="_blank" download>Floorplan-{{i+1}}</a></td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
      </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/csagentdashboard/csagentdashboard.component.html